import axiosApi from '@/api/axiosApi';


export const getProductList = (data) => axiosApi({
  method: 'POST',
  url: '/intserv/coop/listAll',
  data,
});
